import { render, staticRenderFns } from "./AgreementOkasan.vue?vue&type=template&id=25639d6f&scoped=true&"
import script from "./AgreementOkasan.vue?vue&type=script&lang=ts&"
export * from "./AgreementOkasan.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementOkasan.vue?vue&type=style&index=0&id=25639d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25639d6f",
  null
  
)

export default component.exports